var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ui-auth"},[_c('div',{staticClass:"title"},[_c('UiText',{attrs:{"size":"title-01","color":"black"}},[_vm._v(_vm._s(_vm.$t('home.title')))])],1),_c('div',{staticClass:"message"},[_c('UiText',{attrs:{"size":"article","color":"black"}},[_vm._v(_vm._s(_vm.$t('home.message')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }